<script>
  import DialogDocument from '../../documents/components/DialogDocument.svelte';
  import Dialog from '../../lib/components/Dialog.svelte';
  import { t9n } from '../../lib/translate';
  import { TS } from '../../config/translation-keys';

  export let items;
  export let width = 410;
  export let on_row_click = null;
  export let label;
  export let clicked_id;

  const handle_row_click = index => {
    clicked_id = index;
    if (on_row_click !== null) on_row_click();
  };

  const open_dialog_notice = () => {
    let target = document.querySelector('.notice-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'dialog-notice',
        title: t9n(TS.DIALOG_TITLE_UNKNOWN_ERROR),
        content: t9n(TS.ERROR_LOGIN_NEEDS_APPROVAL),
        buttons: [
          {
            label: t9n(TS.REG_FORM_OK),
            action: async () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });
    dialog.open();
  };
</script>

<div class="label">
  <p>{label}</p>
</div>
{#each items as item, i}
  {#if item.active === false}
    {#if item.status.login === 'approved'}
      <div
        class="list_item"
        on:click={() => handle_row_click(item.merchant_uuid)}>
        <p>{item.name}</p>
      </div>
    {:else}
      <div class="list_item_active">
        <p class='mobile-text'>{item.name}</p>
        <i
          class="material-icons active-pos error-icon mobile-icon"
          on:click={() => open_dialog_notice()}>
          error
        </i>
      </div>
    {/if}
  {:else}
    <div class="list_item_active">
      <p class='mobile-text'>{item.name}</p>
      <i class="material-icons active-pos mobile-icon">
        done
      </i>
    </div>
  {/if}
{/each}

<div class="notice-dialog" />

<style>
  .error-icon {
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .error-icon:hover {
    color: var(--invalid-color);
    transition: all 0.3s ease;
  }

  .list_item {
    color: #757575;
    height: 55px;
    border-bottom: 1px solid #757575;
    text-align: left;
    display: inline-block;
    width: 410px;
  }

  .list_item_active {
    color: #757575;
    height: 55px;
    border-bottom: 1px solid #757575;
    text-align: left;
    display: inline-block;
    width: 410px;
  }

  .list_item:hover {
    border-bottom: 1px solid black;
    background-color: #e5e5e5;
    cursor: pointer;
  }

  .label {
    color: #757575;
    height: 55px;
    border-bottom: 1px solid #757575;
    text-align: left;
    display: inline-block;
    width: 410px;
  }

  .active-pos {
    position: relative;
    color: #757575;
    top: -23px;
    /*top: 0px;*/
    /*left: 50px;*/
  }

  p {
    margin: 0;
    padding-top: 20px;
    padding-left: 15px;
  }

  i {
    margin: 0;
  }

  .mobile-icon {
    left: 375px;
  }

  /* Mobile Mode
  ************************************/

  @media screen and (max-width: 768px) {
      .label {
          width: 100%;
          overflow: hidden;
      }

      .list_item {
          width: 100%;
          overflow: hidden;
      }

      .list_item_active {
          width: 100%;
          overflow: hidden;
      }

      .mobile-text {
          margin-left: 10px;
      }

      .mobile-icon {
          left: 0;
      }
  }
</style>
